import React from 'react'
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { hardcodeDropdown, findLabelByValue } from "./constants";
import styles from "./styles.module.scss";
import ContactDetails from './ContactDetails';

// export const headerStyle = { padding: "0 10px", width: "20%" };

const Header = ({ headerData, setHeaderData, listing = false, purchaseType }) => {
    return (
        <>
            <div className={`${styles["header-style"]} `}>
                <AInput
                    value={headerData?.Text}
                    handler={(val) => {
                        setHeaderData((prev) => ({ ...prev, Text: val }));
                    }}
                    placeholder={"Text*"}
                    maxLength={100}
                    style={{ height: "34px" }}
                />
            </div>
            <div className={`${styles["header-style"]} `}>
                <AAutoComplete
                    currentValue={headerData?.Campaign_Name}
                    handleChange={(value) => {
                        setHeaderData((prev) => ({ ...prev, Campaign_Name: value }));
                    }}
                    items={hardcodeDropdown?.Campaign_Name}
                    isMulti={false}
                    placeholder={"Campaign name"}
                    height="34px"
                    isClearable={true}
                />
            </div>

            <div className={`${styles["header-style"]} `}>
                <AAutoComplete
                    currentValue={headerData?.Doc_Type}
                    handleChange={(value) => {
                        setHeaderData((prev) => ({ ...prev, Doc_Type: value }));
                    }}
                    items={
                        ["capexPr", "opexPr"].includes(!listing ? purchaseType?.value : purchaseType)
                            ? hardcodeDropdown?.Doc_Type?.filter((item) =>
                                ["ZMAN", "ZDIG", "ZMRK"].includes(item.value)
                            )
                            : (!listing ? purchaseType?.value : purchaseType) === "servicePr"
                                ? hardcodeDropdown?.Doc_Type?.filter((item) => item.value === "ZSER")
                                : (!listing ? purchaseType?.value : purchaseType) === "normalPr"
                                    ? hardcodeDropdown?.Doc_Type?.filter((item) => item.value === "ZPAK")
                                    : hardcodeDropdown?.Doc_Type
                    }
                    isMulti={false}
                    placeholder={"DOC TYPE*"}
                    height="34px"
                    isClearable={true}
                />
            </div>
            <ContactDetails
                headerData={headerData}
                setHeaderData={setHeaderData}
                listing={listing}
            />
        </>
    );
}

export default Header;